import { render, staticRenderFns } from "./ComponentServicesToPay.vue?vue&type=template&id=5507aa6e&scoped=true&"
import script from "./ComponentServicesToPay.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ComponentServicesToPay.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ComponentServicesToPay.vue?vue&type=style&index=0&id=5507aa6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507aa6e",
  null
  
)

export default component.exports